import FilterForm from "../../../component/FilterForm/FilterForm";
import React, {useState} from "react";
import TextField from "@mui/material/TextField";
import Select from "react-select";
import {statusList} from "./lists/statusList";
import {statusNegativacaoList} from "./lists/statusNegativacaoList";
import {statusProtestoList} from "./lists/statusProtestoList";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {handleChangeData} from "../../../utils/handleChangeData";
import {ApiUrl} from "../../../auth/authMethods";
import SelectInput from "../../../component/SelectInput";
import {InputLabelProps} from "../../../utils/InputLabelProps";
import {handleChangeNumber} from "../../../utils/handleChangeNumber";
import {bankList} from "../../../utils/bankList";

export default function FilterBoleto({filter, setFilter, setLoadData, setPage}) {

    const [lgShow, setLgShow] = useState(false);

    const [eventoId, setEventoId] = useState('');
    const [numeroLote, setNumeroLote] = useState('');
    const [parcela, setParcela] = useState('');
    const [identificador, setIdentificador] = useState('');
    const [nossoNumero, setNossoNumero] = useState('');
    const [banco, setBanco] = useState(null);

    //é utilizado o campo linha digitavel pq esse é
    //o nome real dos numeros no codigo de barras
    const [linhaDigitavel, setLinhaDigitavel] = useState('');
    const [nomeVendedor, setNomeVendedor] = useState('');
    const [dataVencimento, setDataVencimento] = useState('')
    const [status, setStatus] = useState('')
    const [statusNegativacao, setStatusNegativacao] = useState('')
    const [statusProtesto, setStatusProtesto] = useState('')

    const [eventoList, setEventoList] = useState([]);

    const handlesSubmit = (e) => {

        e.preventDefault();

        setFilter({
            ...(eventoId && {eventoId}),
            ...(numeroLote && {numeroLote}),
            ...(parcela && {parcela}),
            ...(identificador && {identificador}),
            ...(nomeVendedor && {nomeVendedor}),
            ...(nossoNumero && {nossoNumero}),
            ...(linhaDigitavel && {linhaDigitavel}),
            ...(dataVencimento && {dataVencimento: dataVencimento + 'T00:00:00'}),
            ...(status && {status}),
            ...(statusNegativacao && {statusNegativacao}),
            ...(statusProtesto && {statusProtesto}),
            ...(banco && {banco}),
        });

        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    console.log(filter)

    const clearFilter = () => {
        setEventoId('')
        setNumeroLote('')
        setParcela('')
        setIdentificador('')
        setNomeVendedor('')
        setNossoNumero('')
        setLinhaDigitavel('')
        setDataVencimento('')
        setStatus('')
        setStatusNegativacao('')
        setStatusProtesto('')
        setBanco('')

        setFilter({});
        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    return <>
        <FilterForm
            handleSubmit={handlesSubmit} clearFilter={clearFilter}
            lgShow={lgShow} setLgShow={setLgShow}
            showSecondaryButton={Object.keys(filter).length !== 0}
        >
            <SelectInput
                url={ApiUrl + '/evento/list?status=ABERTO&size=20000'}
                list={eventoList}
                set={setEventoList}
                defaultValue={eventoId}
                setObj={setEventoId}
                returnList={() => {
                    let returnList = []
                    eventoList.forEach((item) => {
                        returnList.push({value: item.id, label: `${item.nomeEvento}`})
                    })
                    return returnList
                }}
                placeholder={"Evento"}
                isClearable
                fullWidth
            />
            <Select
                className="basic-single"
                classNamePrefix="select"
                id="form_select"
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                options={bankList}
                defaultValue={bankList.find(item => item.value === banco)}
                onChange={(e) => setBanco(e?.value)}
                placeholder='Banco'
            />
            <TextField
                label="Número do Lote"
                className='mt-2'
                inputProps={{
                    maxLength: 90
                }}
                value={numeroLote}
                onChange={(e) => setNumeroLote(e.target.value)}
                InputLabelProps={InputLabelProps}
                fullWidth
            />
            <TextField
                label="Parcela"
                type="text"
                value={parcela}
                inputProps={{
                    minLength: 0,
                    maxLength: 3,
                }}
                onChange={(e) => handleChangeNumber(setParcela, e.target.value)}
                InputLabelProps={InputLabelProps}
                fullWidth
            />
            <TextField
                label="Identificador"
                inputProps={{
                    maxLength: 40
                }}
                value={identificador}
                onChange={(e) => setIdentificador(e.target.value)}
                InputLabelProps={InputLabelProps}
                fullWidth
            />
            <TextField
                label="Nome do Vendedor"
                inputProps={{
                    maxLength: 60
                }}
                value={nomeVendedor}
                onChange={(e) => setNomeVendedor(e.target.value)}
                InputLabelProps={InputLabelProps}
                fullWidth
            />
            <TextField
                label="Nosso Número"
                inputProps={{
                    maxLength: 40
                }}
                value={nossoNumero}
                onChange={(e) => setNossoNumero(e.target.value)}
                InputLabelProps={InputLabelProps}
                fullWidth
            />
            <TextField
                label="Código de Barras"
                inputProps={{
                    maxLength: 40
                }}
                value={linhaDigitavel}
                onChange={(e) => setLinhaDigitavel(e.target.value)}
                InputLabelProps={InputLabelProps}
                fullWidth
            />
            <DatePicker
                label="Data de Vencimento"
                sx={{
                    width: '100%',
                    zIndex: 0
                }}
                defaultValue={dataVencimento ? dayjs(dataVencimento) : null}
                onChange={(e) => handleChangeData(e, setDataVencimento)}
                InputLabelProps={InputLabelProps}
            />
            <Select
                className="basic-single"
                classNamePrefix="select"
                id="form_select"
                required={false}
                defaultValue={statusList.filter(item => item.value === status)}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                options={statusList}
                onChange={(e) => setStatus(e?.value)}
                InputLabelProps={InputLabelProps}
                placeholder={'Status'}
            />
            <Select
                className="basic-single"
                classNamePrefix="select"
                id="form_select"
                required={false}
                defaultValue={statusNegativacaoList.filter(item => item.value === statusNegativacao)}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                options={statusNegativacaoList}
                onChange={(e) => setStatusNegativacao(e?.value)}
                InputLabelProps={InputLabelProps}
                placeholder={'Status de Negativação'}
            />
            <Select
                className="basic-single"
                classNamePrefix="select"
                id="form_select"
                required={false}
                defaultValue={statusProtestoList.filter(item => item.value === statusProtesto)}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                options={statusProtestoList}
                onChange={(e) => setStatusProtesto(e?.value)}
                InputLabelProps={InputLabelProps}
                placeholder={'Status de Protesto'}
            />
        </FilterForm>
    </>
}